<div class="modal-header bg-head py-2">
  <h6 class="modal-title">Admin : Question Management : Assign</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>


<div class="row">
  <div class="col-12 border-bottom headersize py-2">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center px-3">

      <!-- Left: Path Title and Exam Info -->
      <div class="mb-2 mb-md-0">
        <!-- Path Title at the Top -->
        <span class="path-class m-0">{{ path }}</span>
      </div>

    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 border-bottom headersize">
    <div class="d-flex flex-wrap align-items-center bg-deep-blue px-2 py-1 gap-2 gap-md-4">

      <!-- Only show exam info if available -->
      <ng-container *ngIf="courseName && examYearName && examAgencyName">
        <span class="fw-bold text-white section-label">Exam Agency Name&nbsp;:</span>
        <span class="fw-normal text-white-50 section-value me-3">{{ examAgencyName }}</span>
        <span class="fw-bold text-white section-label">Course Name&nbsp;:</span>
        <span class="fw-normal text-white-50 section-value me-3">{{ courseName }}</span>
        <span class="fw-bold text-white section-label">Year&nbsp;:</span>
        <span class="fw-normal text-white-50 section-value me-3">{{ examYearName }}</span>
      </ng-container>

      <!-- BUTTONS always shown, aligned right -->
      <div class="d-flex align-items-center ms-auto gap-2">
        <button
        *ngIf="savedCourseSelection"
          type="button"
          class="btn btn-sm border border-white text-white ms-1 ms-md-3 mt-2 mt-md-0"
          (click)="clearSelectedCourseWithRoute()"
          style="min-width:80px"
        >
          Clear
        </button>
        <button
          *ngIf="!QuestionId"
          type="button"
          class="btn btn-sm btn-outline-primary select-course-btn px-4"
          (click)="openSelectPopUp()"
          style="min-width:140px; font-size: 14 px; font-weight: 400; border-radius: 3px; background: #fff;"
        >
          {{ savedCourseSelection ? 'Change course to assign multiple questions' :'Select course to assign multiple questions'}}
        </button>

      </div>
    </div>
  </div>
</div>



<div class="modal-body question-assign m-body px-0">
  <form [formGroup]="assignForm">
    <div class="row" formArrayName="questionsArray">
      <div class="col-12 mb-4 question-height"
      *ngFor="let item of questionArray?.controls; let i = index"
      [formGroupName]="i">
        <div class="col-12 bg-head-study py-2 px-3 d-flex flex-wrap justify-content-between align-items-center text-white">


          <!-- Flashcard ID (Centered) -->
          <div class="d-flex align-items-center">
            <h4 class="headertext-color-assign mb-0 me-3">
              Question:
              <span class="number-style">
                {{ Questions[i]?.Question_ID }} {{Questions[i]?.Display_Order ? '' : ''}}
                ({{Questions[i]?.Question_Status_Type_Name}})
              </span>
            </h4>
            <input
            type="checkbox"
            formControlName="selected"
            class="form-check-input ms-2"
            (change)="onQuestionSelectedChange(i, $event)"
            *ngIf="savedCourseSelection "
            />
          </div>


          <div class="d-flex gap-3">
          <!-- Created By & Date -->
          <div class="d-flex align-items-center">
            <h6 class="mb-0">
              <strong>Created By:</strong> {{ Questions[i]?.Created_By }}
                ({{ Questions[i]?.Creation_Date | date: 'short' }})
            </h6>
          </div>
          <!-- Updated By & Date -->
          <div class="d-flex align-items-center">
            <h6 class="mb-0">
              <strong>Updated By:</strong>
              {{ Questions[i]?.Updated_By }}
                ({{ Questions[i]?.Updated_Date | date: 'short' }})
            </h6>
          </div>
        </div>

        <div class="">
          <i class="fa fa-pencil-square-o fs-5 pointer-cursor" *ngIf="!isEdit"
          (click)="triggerParentFunction(Questions[i])" aria-hidden="true"></i>
          <span class="me-2 fs-5 fw-bold" *ngIf="Questions[i]?.Display_Order"> {{Questions[i]?.Display_Order}}</span>

          <!-- <i class="fa fa-pencil-square-o fs-5 pointer-cursor" aria-hidden="true"></i> -->
        </div>
        </div>
        <div  class="row ms-4">
          <div class="col-md-6">
            <div class="row">
              <div class="col-12" id="question">
                <span [innerHtml]="this.SanitizeHTML(Questions[i]?.Question_Text ?? '')"></span>
              </div>
            </div>
            <div  class="col-12">
              <div  class="row" *ngFor="let answer of Questions[i]?.AllAnswers">
                <div class="col-2 px-0 AnswerChoicelabel text-end">
                  {{ answer?.Right_Answer_Ind === 'Y' ? 'Right Answer' : 'Wrong Answer' }} :
                </div>
                <div  class="col-10 px-1 AnswerChoicelabel1">
                  <div [innerHtml]="
                   this.SanitizeHTML(answer?.Answer_Choice_Text ??'')">
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6">
            <div class="col-12">
              <h4 class="my-1">Applicable Course Type</h4>
              <div class="row">
                <div class="d-flex flex-wrap gap-3" formArrayName="courseCategoryType">
                  <div
                    *ngFor="let ccType of getFormControlsForQuestion(i, 'courseCategoryType')?.controls; let cCI = index"
                    [formGroupName]="cCI"
                  >
                    <div>
                      <input
                        type="checkbox"
                        formControlName="SelectedInd"
                        (change)="onCourseCategoryTypeChange($event, ccType,i)"
                      />
                      {{ ccType.value.CourseCategoryTypeName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h4 class="my-2">Applicable Courses</h4>
              <ng-container *ngFor="let item of courseCategoryList; let CCI = index">
                <div class="my-3" *ngIf="getApplicableCourseTypeElementForAQuestion(i, CCI)?.get('SelectedInd')?.value">
                  <div class="d-flex align-items-baseline gap-3">
                    <h5>{{ item.Description }}</h5>
                    <i class="fa fa-plus" (click)="addApplicableCourse(i, item)"></i>
                  </div>

                  <div *ngIf="!checkifCategoryTypeNotEmpty(item.Code, i)">
                    <div class="table-responsive">
                      <table class="table ">
                        <thead class="">
                          <tr>
                            <th class="border-0" style="width: 25%;">Exam Agency <span class="text-danger">*</span></th>
                            <th class="border-0" style="width: 25%;">Course Name <span class="text-danger">*</span></th>
                            <th class="border-0" style="width: 20%;">Difficulty Level <span class="text-danger">*</span></th>
                            <th class="border-0" style="width: 20%;"> Year/Month <span class="text-danger">*</span></th>
                            <th class="border-0" class="text-center border-0" style="width: 10%;">Past Year</th>
                          </tr>
                        </thead>
                        <tbody formArrayName="applicableCourses" class="border-0">
                          <ng-container *ngFor="let appExam of getFormControlsForQuestion(i, 'applicableCourses')?.controls; let aCI = index">
                            <tr
                              class="border-0"
                              [formGroupName]="aCI"
                              *ngIf="appExam.value.type === item.Code && appExam.value.deleteInd === 'N'"
                            >
                              <td class="border-0 px-1 pt-0 pb-1">
                                <select class="form-control" formControlName="examAgency" (change)="fetchCourseBasedOnExam(appExam, item)">
                                  <option [value]="null" hidden></option>
                                  <option *ngFor="let s of appExam.value.examAgencyList" [value]="s.Code">
                                    {{ s.Description }}
                                  </option>
                                </select>
                              </td>
                              <td class="border-0 px-1 pt-0 pb-1">
                                <select class="form-control" formControlName="courseId" (change)="fetchCourseYear(appExam, item)">
                                  <option [value]="null" hidden></option>
                                  <option *ngFor="let s of appExam.value.courseList" [value]="s.Code">
                                    {{ s.Description }}
                                  </option>
                                </select>
                              </td>
                              <td class="border-0 px-1 pt-0 pb-1">
                                <select class="form-control" formControlName="QuestionDifficultyLevelTypeCode">
                                  <option [value]="null" hidden></option>
                                  <option *ngFor="let s of QuestionDifficulty" [value]="s.Code">
                                    {{ s.Description }}
                                  </option>
                                </select>
                              </td>
                              <td class="border-0 pt-0 pb-1">
                                <select class="form-control" formControlName="examYear"
                                  (change)="checkIfCourseYearAlreadySelected(appExam, getFormControlsForQuestion(i, 'applicableCourses'), aCI, i)">
                                  <option [value]="null" hidden></option>
                                  <option *ngFor="let s of appExam.value.courseYear" [value]="s.Code">
                                    {{ s.Description }}
                                  </option>
                                </select>
                                <small class="text-danger" *ngIf="appExam.get('examYear')?.touched && appExam.get('examYear')?.hasError('sameCourse')">
                                  The course Year / Month is already selected.
                                </small>
                              </td>
                              <td class="text-center border-0 pt-0 pb-1">
                                <div class="d-flex gap-2 mt-2 justify-content-center align-items-center">
                                <input type="checkbox" formControlName="pastYear">
                                <i class="fa fa-trash pointer-cursor" (click)="deleteApplicableCourseElement(i, aCI)"></i>
                              </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>
<div class="modal-footer">
  <button
    type="button"
    class=" bl-btn btn btn-sm"
    (click)="onSave()"
  >
    Save
  </button>
  <button
    type="button"
    class=" btn btn-sm bg-light border "
    (click)="this.onCross()">
    Cancel
  </button>
</div>
